/**
 * Note Controller
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Aditya
 */
angular.module('flsControllers').controller('NoteController', [
    '$scope',
    '$window',
    '$http',
    'Note',
    function($scope, $window, $http, Note) {
    // Set the Loading state
    $scope.loading = false;

    // Set initial number of Comments
    $scope.notes = [];

    // Init the new form
    $scope.form = {};

    // Init the Context
    $scope.context = {};

    // Number of Notes visible
    $scope.length = 0;

    /**
     * Keep the notes provate
     *
     * @type {boolean}
     */
    $scope.keep_private = 0;

    /**
     * Offset # of notes
     * @type {Number}
     */
    $scope.offset = 10;

    // Init the Controller with the Context Type and ID
    $scope.init = function(context_type, context_id, keep_private = true, offset = 10) {
        // Set loading state to true
        $scope.loading = true;

        // Compile the Context
        $scope.context = {
            context_type:context_type,
            context_id:context_id
        };

        // Push default form value
        $scope.form = {
            is_private:keep_private,
        };
        // Store the base keep_private settings
        $scope.keep_private = keep_private;
        // Store the base keep_private settings
        $scope.offset = offset;
        // Load the notes in context
        $scope.loadNotes($scope.context);
    }

    // Refresh the Notes
    $scope.loadNotes = function($context) {
        Note.get($context, function(resource) {
            $scope.notes  = resource.data;
            $scope.length = resource.data.length;
            }, function($error){
                _.each($error.data, function(error){
                    $.publish('resource.error', error);
                });
            });
        // Set loading state to false
        $scope.loading = false;
    }

    // Add the resurce
    $scope.addNote = function(form){
        // Match context
        var context = $scope.context;

        // Merge with Form
        var newNote = angular.extend({}, form, context);

        // Set loading state to false
        $scope.loading = true;

        // Send store call
        Note.save(newNote, function(response){
            if(response){
                // Clean up the form
                form.content = null;
                form.is_private = $scope.keep_private;

                // Load the notes in context
                $scope.loadNotes(context);
            } else {
                /*display an error maybe? */

                // Set loading state to false
                $scope.loading = false;
            };
         }, function($error){
            _.each($error.data, function(error){
                $.publish('resource.error', error);
            });
        });
    }

    /**
     * Toggle visibility of the note
     *
     * @param  {Note} note
     * @return {void}
     */
    $scope.togglePrivate = function(note){
        // Toggle value
        note.is_private = !note.is_private;
        // save the note
        return this.saveNote(note);
    }

    /**
     * Save the actual note's whatever changes
     *
     * @param  {Note} note
     * @return {void}
     */
    $scope.saveNote = function(note){
        $scope.loading = true;
        Note.update(angular.extend({}, note, {_method:'PUT'}), function(response){
            $scope.loading = false;
        }, function($error){
            _.each($error.data, function(error){
                $.publish('resource.error', error);
            });
        })
    }

    // Remove the Resource
    $scope.deleteNote = function(id){
        // Set loading state to true
        $scope.loading = true;

        // iterate through scope.notes to find the one with ID
        angular.forEach($scope.notes, function(note, index) {
            if(id === note.id) {
                // Send destroy call (via POST with additional field, '_method' = 'DELETE')
                Note.delete({id:id}, function(response){
                    // Upon success, remove the element from the $scope.notes
                    if(response){
                        // Load the notes in context
                        $scope.loadNotes($scope.context);
                    } else {
                        // Set loading state to false
                        $scope.loading = false;
                    };
                });
            }
        });
    }

    /**
     * Display the unique authors from offset
     *
     * @return {string}
     */
    $scope.uniqeAuthors = function() {
        console.log('wut')
        return _.chain(this.notes)
                .take(this.notes.length - this.offset)
                .map('created_by.preferred_name')
                .uniq()
                .join(', ')
                .value()
    }
}]);
